var __WEBPACK_NAMESPACE_OBJECT__ = window.dnn.nodeModules.ReduxDevTools;